var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Suspense, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import { getCookie, setCookie } from '@ciceksepeti/cs-cookie';
import { EventEmitter } from '@ciceksepeti/cs-event-emitter';
import { googleTagManagerInitialControl } from '@ciceksepeti/cs-gtm';
import { initAmplitudeSessionReplay } from '@ciceksepeti/cs-amplitude-helper';
import { Button } from '@ciceksepeti/cs-button';
import '@ciceksepeti/cs-button/styles.css';
import Header from '@ciceksepeti/cs-header';
import '@ciceksepeti/cs-header/styles.css';
import { Icon } from '@ciceksepeti/cs-icon';
import '@ciceksepeti/cs-icon/styles.css';
import { HeaderLite } from '@ciceksepeti/cs-header-lite';
import '@ciceksepeti/cs-header-lite/styles.css';
import Footer from '@ciceksepeti/cs-footer';
import '@ciceksepeti/cs-footer/styles.css';
import { SegmentProvider } from '@ciceksepeti/cs-segment';
import { isMobile } from '@ciceksepeti/cs-user-agent';
import Metatags from '@components/metatags';
import RouteEvents from '@components/route-events';
import ScrollRestoration from '@components/scroll-restoration';
import Section from '@components/section';
import BottomWidgets from '@components/bottom-widgets';
import GlobalMethods from '@components/global-methods';
import AuthenticationLogics from '@components/authentication-logics';
import SegmentEvents from '@components/segment-events';
import Cookies from '@constants/cookies';
import Events from '@constants/events';
import HomePageTypes from '@constants/home-page-types';
import LAYOUT from '@constants/layout';
import Services from '@constants/services';
import { Routes } from '@constants/routes';
import { useCommons } from '@hooks/use-commons';
import { useMobileQuery } from '@hooks/use-mobile-query';
import { getTagManagerPersonalData } from '@services/gtm';
import { getServerTime } from '@services/common';
import styles from './styles.module.scss';
var NotificationContainer = React.lazy(function () { return import('@components/notification-container'); });
var VerificationContainer = React.lazy(function () { return import('@components/verification-container'); });
var isHeaderAndLiveChatWidgetSticky = true;
var initSessionReplay = function () { return __awaiter(void 0, void 0, void 0, function () {
    var API_KEY, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                API_KEY = process.env.AMPLITUDE_API_KEY;
                return [4 /*yield*/, initAmplitudeSessionReplay({
                        amplitude: {
                            apiKey: API_KEY
                        }
                    })];
            case 1:
                _a.sent();
                return [3 /*break*/, 3];
            case 2:
                error_1 = _a.sent();
                console.warn('Session replay failed', error_1);
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); };
var Main = function (props) {
    var _a = props.layout, layout = _a === void 0 ? LAYOUT.SIDEBARLEFT : _a;
    var variables = useCommons().variables;
    var resources = variables.resources;
    var params = new URLSearchParams(window.location.search);
    var userAgent = navigator.userAgent;
    var isMobileDevice = isMobile(userAgent);
    var hasMobileQuery = useMobileQuery();
    var homePageTypeCookieValue = getCookie(Cookies.HOME_PAGE_TYPE);
    var homePageType = Number(homePageTypeCookieValue) || HomePageTypes.CS;
    var initialSearchTerm = params.get('qt') || params.get('query') || '';
    var isCartPage = window.location.pathname.includes(Routes.CART);
    var isDeliveryAddressPage = window.location.pathname.includes(Routes.DELIVERY_ADDRESS);
    var isMembershipLoginPage = window.location.pathname.includes(Routes.MEMBERSHIP_LOGIN);
    var isAdditionalProductsPage = window.location.pathname.includes(Routes.ADDITIONAL_PRODUCTS);
    var isCardMessagePage = window.location.pathname.includes(Routes.CARD_MESSAGE);
    var isInvoiceInformationPage = window.location.pathname.includes(Routes.INVOICE_INFORMATION);
    var handleBackButtonClick = function () {
        var eventEmitter = new EventEmitter();
        eventEmitter.dispatch(Events.HEADER_BACK_BUTTON_CLICK, null);
    };
    var liteHeaderStartAdornment = isMobileDevice &&
        (isDeliveryAddressPage ||
            isAdditionalProductsPage ||
            isCardMessagePage ||
            isInvoiceInformationPage) ? (_jsx(Button, { variant: "text", color: "neutral-50-outline", dimension: "large", noPadding: true, className: styles.backButton, "aria-label": "Geri", title: "Geri", onClick: handleBackButtonClick, children: _jsx(Icon, { iconName: "icon-chevron-left" }) })) : null;
    useEffect(function () {
        var serverTimeCookie = getCookie(Cookies.SERVER_TIME);
        if (serverTimeCookie)
            return;
        (function () { return __awaiter(void 0, void 0, void 0, function () {
            var response, serverTime, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, getServerTime()];
                    case 1:
                        response = _a.sent();
                        serverTime = response.serverTime;
                        setCookie(Cookies.SERVER_TIME, serverTime, { path: '/', maxAge: undefined });
                        return [3 /*break*/, 3];
                    case 2:
                        error_2 = _a.sent();
                        console.error(error_2);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); })();
    }, []);
    useEffect(function () {
        void (function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, new Promise(function (resolve) { return setTimeout(resolve, 250); })];
                    case 1:
                        _a.sent();
                        // TODO: Remove this after all projects are migrated from Tangram
                        return [4 /*yield*/, googleTagManagerInitialControl({
                                getGtmData: getTagManagerPersonalData
                            })];
                    case 2:
                        // TODO: Remove this after all projects are migrated from Tangram
                        _a.sent();
                        return [4 /*yield*/, initSessionReplay()];
                    case 3:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); })();
    }, []);
    return (_jsxs(_Fragment, { children: [_jsx(RouteEvents, {}), _jsx(ScrollRestoration, {}), _jsx(AuthenticationLogics, {}), _jsx(Metatags, {}), !hasMobileQuery ? (_jsx(_Fragment, { children: layout === LAYOUT.FULLWIDTH_LITE_HEADER ||
                    layout === LAYOUT.FULLWIDTH_LITE_HEADER_NO_FOOTER ||
                    layout === LAYOUT.CONTAINER_LITE_HEADER_NO_FOOTER ? (_jsx(HeaderLite, { startAdornment: liteHeaderStartAdornment })) : (_jsx(Header, { apiUrl: Services.API_URL, isSticky: isHeaderAndLiveChatWidgetSticky, userAgent: userAgent, resources: resources, isHomePage: false, homePageType: homePageType, initialSearchTerm: initialSearchTerm, linkComponent: NavLink, responsiveSearchBarDisplayCondition: isCartPage || isMembershipLoginPage ? 'hidden' : 'visible' })) })) : null, _jsx(Section, { isLiveChatWidgetSticky: isHeaderAndLiveChatWidgetSticky, layout: layout }), !hasMobileQuery ? (_jsx(_Fragment, { children: layout !== LAYOUT.FULLWIDTH_LITE_HEADER_NO_FOOTER &&
                    layout !== LAYOUT.CONTAINER_LITE_HEADER_NO_FOOTER ? (_jsx(Footer, { apiUrl: Services.API_URL, userAgent: userAgent })) : null })) : null, _jsx(BottomWidgets, {}), _jsx(GlobalMethods, {}), _jsx(SegmentProvider, { value: {
                    API_URL: Services.API_URL
                }, children: _jsx(SegmentEvents, {}) }), _jsxs(Suspense, { fallback: _jsx(_Fragment, {}), children: [_jsx(NotificationContainer, {}), _jsx(VerificationContainer, {})] })] }));
};
export default Main;
